import React from "react";
import * as SC from "./CampaignBudget.styled";
import Section from "../Section/Section";
import { sumValueFromDictKey } from "../../../../../utils/Helpers";

const CampaignBudget = ({ lifeTimeBudget, metricsToUse }) => {
  const totalSpent = sumValueFromDictKey(metricsToUse, "totalSpent");

  return (
    <SC.Wrapper>
      <Section title={"Budget"}>
        <div>
          {totalSpent}€<SC.TotalBudget> /{lifeTimeBudget}€</SC.TotalBudget>
        </div>
      </Section>
      <div>
        <SC.BoostButton>Boost now</SC.BoostButton>
      </div>
    </SC.Wrapper>
  );
};

export default CampaignBudget;
